module.exports = __webpack_public_path__ + "static/media/upload.fbf70c23.svg";